const initialState = {
    toast: false,  // Add this line to your initial state
};

export const notification = (state = initialState, action) => {
  switch (action.type) {

    case "SET_SELECTED_TOAST": {  // Add this case to handle the new action
      return {
        ...state,
        toast: action.payload,
      };
    }

    default:
      return state;
  }
};
export default notification;